import { CLASSES } from 'game/CLASSES';
import { TIERS } from 'game/TIERS';

// region SL1
export const DEATH_KNIGHT_DF1_ID = 1526;
export const DEMON_HUNTER_DF1_ID = 1527;
export const DRUID_DF1_ID = 1528;
export const EVOKER_DF1_ID = 1530;
export const HUNTER_DF1_ID = 1529;
export const MAGE_DF1_ID = 1531;
export const MONK_DF1_ID = 1532;
export const PALADIN_DF1_ID = 1533;
export const PRIEST_DF1_ID = 1534;
export const ROGUE_DF1_ID = 1535;
export const SHAMAN_DF1_ID = 1536;
export const WARLOCK_DF1_ID = 1537;
export const WARRIOR_DF1_ID = 1538;

type DF1_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_DF1_ID
  | typeof DEMON_HUNTER_DF1_ID
  | typeof DRUID_DF1_ID
  | typeof EVOKER_DF1_ID
  | typeof HUNTER_DF1_ID
  | typeof MAGE_DF1_ID
  | typeof MONK_DF1_ID
  | typeof PALADIN_DF1_ID
  | typeof PRIEST_DF1_ID
  | typeof ROGUE_DF1_ID
  | typeof SHAMAN_DF1_ID
  | typeof WARLOCK_DF1_ID
  | typeof WARRIOR_DF1_ID;

export const DF1_TIER_BY_CLASSES: Record<number, DF1_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_DF1_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_DF1_ID,
  [CLASSES.DRUID]: DRUID_DF1_ID,
  [CLASSES.EVOKER]: EVOKER_DF1_ID,
  [CLASSES.HUNTER]: HUNTER_DF1_ID,
  [CLASSES.MAGE]: MAGE_DF1_ID,
  [CLASSES.MONK]: MONK_DF1_ID,
  [CLASSES.PALADIN]: PALADIN_DF1_ID,
  [CLASSES.PRIEST]: PRIEST_DF1_ID,
  [CLASSES.ROGUE]: ROGUE_DF1_ID,
  [CLASSES.SHAMAN]: SHAMAN_DF1_ID,
  [CLASSES.WARLOCK]: WARLOCK_DF1_ID,
  [CLASSES.WARRIOR]: WARRIOR_DF1_ID,
};
// endregion

// region DF2
export const DEATH_KNIGHT_DF2_ID = 1540;
export const DEMON_HUNTER_DF2_ID = 1541;
export const DRUID_DF2_ID = 1542;
export const EVOKER_DF2_ID = 1543;
export const HUNTER_DF2_ID = 1544;
export const MAGE_DF2_ID = 1545;
export const MONK_DF2_ID = 1546;
export const PALADIN_DF2_ID = 1547;
export const PRIEST_DF2_ID = 1548;
export const ROGUE_DF2_ID = 1549;
export const SHAMAN_DF2_ID = 1550;
export const WARLOCK_DF2_ID = 1551;
export const WARRIOR_DF2_ID = 1552;

type DF2_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_DF2_ID
  | typeof DEMON_HUNTER_DF2_ID
  | typeof DRUID_DF2_ID
  | typeof EVOKER_DF2_ID
  | typeof HUNTER_DF2_ID
  | typeof MAGE_DF2_ID
  | typeof MONK_DF2_ID
  | typeof PALADIN_DF2_ID
  | typeof PRIEST_DF2_ID
  | typeof ROGUE_DF2_ID
  | typeof SHAMAN_DF2_ID
  | typeof WARLOCK_DF2_ID
  | typeof WARRIOR_DF2_ID;

export const DF2_TIER_BY_CLASSES: Record<number, DF2_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_DF2_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_DF2_ID,
  [CLASSES.DRUID]: DRUID_DF2_ID,
  [CLASSES.EVOKER]: EVOKER_DF2_ID,
  [CLASSES.HUNTER]: HUNTER_DF2_ID,
  [CLASSES.MAGE]: MAGE_DF2_ID,
  [CLASSES.MONK]: MONK_DF2_ID,
  [CLASSES.PALADIN]: PALADIN_DF2_ID,
  [CLASSES.PRIEST]: PRIEST_DF2_ID,
  [CLASSES.ROGUE]: ROGUE_DF2_ID,
  [CLASSES.SHAMAN]: SHAMAN_DF2_ID,
  [CLASSES.WARLOCK]: WARLOCK_DF2_ID,
  [CLASSES.WARRIOR]: WARRIOR_DF2_ID,
};
// endregion

// region DF3
export const DEATH_KNIGHT_DF3_ID = 1557;
export const DEMON_HUNTER_DF3_ID = 1558;
export const DRUID_DF3_ID = 1559;
export const EVOKER_DF3_ID = 1560;
export const HUNTER_DF3_ID = 1561;
export const MAGE_DF3_ID = 1562;
export const MONK_DF3_ID = 1563;
export const PALADIN_DF3_ID = 1564;
export const PRIEST_DF3_ID = 1565;
export const ROGUE_DF3_ID = 1566;
export const SHAMAN_DF3_ID = 1567;
export const WARLOCK_DF3_ID = 1568;
export const WARRIOR_DF3_ID = 1569;

type DF3_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_DF3_ID
  | typeof DEMON_HUNTER_DF3_ID
  | typeof DRUID_DF3_ID
  | typeof EVOKER_DF3_ID
  | typeof HUNTER_DF3_ID
  | typeof MAGE_DF3_ID
  | typeof MONK_DF3_ID
  | typeof PALADIN_DF3_ID
  | typeof PRIEST_DF3_ID
  | typeof ROGUE_DF3_ID
  | typeof SHAMAN_DF3_ID
  | typeof WARLOCK_DF3_ID
  | typeof WARRIOR_DF3_ID;

export const DF3_TIER_BY_CLASSES: Record<number, DF3_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_DF3_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_DF3_ID,
  [CLASSES.DRUID]: DRUID_DF3_ID,
  [CLASSES.EVOKER]: EVOKER_DF3_ID,
  [CLASSES.HUNTER]: HUNTER_DF3_ID,
  [CLASSES.MAGE]: MAGE_DF3_ID,
  [CLASSES.MONK]: MONK_DF3_ID,
  [CLASSES.PALADIN]: PALADIN_DF3_ID,
  [CLASSES.PRIEST]: PRIEST_DF3_ID,
  [CLASSES.ROGUE]: ROGUE_DF3_ID,
  [CLASSES.SHAMAN]: SHAMAN_DF3_ID,
  [CLASSES.WARLOCK]: WARLOCK_DF3_ID,
  [CLASSES.WARRIOR]: WARRIOR_DF3_ID,
};
// endregion

// region DF4
export const DEATH_KNIGHT_DF4_ID = 1603;
export const DEMON_HUNTER_DF4_ID = 1604;
export const DRUID_DF4_ID = 1597;
export const EVOKER_DF4_ID = 1594;
export const HUNTER_DF4_ID = 1595;
export const MAGE_DF4_ID = 1605;
export const MONK_DF4_ID = 1596;
export const PALADIN_DF4_ID = 1598;
export const PRIEST_DF4_ID = 1599;
export const ROGUE_DF4_ID = 1600;
export const SHAMAN_DF4_ID = 1606;
export const WARLOCK_DF4_ID = 1601;
export const WARRIOR_DF4_ID = 1602;

type DF4_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_DF4_ID
  | typeof DEMON_HUNTER_DF4_ID
  | typeof DRUID_DF4_ID
  | typeof EVOKER_DF4_ID
  | typeof HUNTER_DF4_ID
  | typeof MAGE_DF4_ID
  | typeof MONK_DF4_ID
  | typeof PALADIN_DF4_ID
  | typeof PRIEST_DF4_ID
  | typeof ROGUE_DF4_ID
  | typeof SHAMAN_DF4_ID
  | typeof WARLOCK_DF4_ID
  | typeof WARRIOR_DF4_ID;

export const DF4_TIER_BY_CLASSES: Record<number, DF4_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_DF4_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_DF4_ID,
  [CLASSES.DRUID]: DRUID_DF4_ID,
  [CLASSES.EVOKER]: EVOKER_DF4_ID,
  [CLASSES.HUNTER]: HUNTER_DF4_ID,
  [CLASSES.MAGE]: MAGE_DF4_ID,
  [CLASSES.MONK]: MONK_DF4_ID,
  [CLASSES.PALADIN]: PALADIN_DF4_ID,
  [CLASSES.PRIEST]: PRIEST_DF4_ID,
  [CLASSES.ROGUE]: ROGUE_DF4_ID,
  [CLASSES.SHAMAN]: SHAMAN_DF4_ID,
  [CLASSES.WARLOCK]: WARLOCK_DF4_ID,
  [CLASSES.WARRIOR]: WARRIOR_DF4_ID,
};
// endregion

// region Common
export const TIER_BY_CLASSES: Record<number, Record<number, number>> = {
  [TIERS.DF1]: DF1_TIER_BY_CLASSES,
  [TIERS.DF2]: DF2_TIER_BY_CLASSES,
  [TIERS.DF3]: DF3_TIER_BY_CLASSES,
  [TIERS.DF4]: DF4_TIER_BY_CLASSES,
};

export type TIER_GEAR_IDS =
  | DF1_TIER_GEAR_IDS
  | DF2_TIER_GEAR_IDS
  | DF3_TIER_GEAR_IDS
  | DF4_TIER_GEAR_IDS;
// endregion
